import { testimonials } from '@/mocks/data';

export default function TestimonialSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-semibold uppercase tracking-wider text-accent-700">用户口碑</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            吃瓜群众说
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            真实用户评价，吃瓜我们是认真的
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {testimonials.slice(0, 3).map((t) => (
            <div
              key={t.id}
              className="bg-background-100 rounded-lg p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
              <div className="mb-3">
                <i className="ri-double-quotes-l text-2xl text-secondary-300"></i>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                {t.content}
              </p>
              <div className="flex items-center gap-0.5 mt-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-xs text-accent-500"></i>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          {testimonials.slice(3, 5).map((t) => (
            <div
              key={t.id}
              className="bg-background-100 rounded-lg p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
              <div className="mb-3">
                <i className="ri-double-quotes-l text-2xl text-secondary-300"></i>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                {t.content}
              </p>
              <div className="flex items-center gap-0.5 mt-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-xs text-accent-500"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}